import muslinTwoBibsTwoP from "./muslinTwo_yg/img_muslinTwoBibsTwo_yg_p.jpg";
import muslinTwoBibsTwo from "./muslinTwo_yg/img_muslinTwoBibsTwo_yg.jpg";

import muslinTwo from "./muslinTwo_yg/img_muslinTwo_yg.jpg";
import muslinTwoP from "./muslinTwo_yg/img_muslinTwo_yg_p.jpg";

import muslinTwoBibsTwoEars from "./muslinTwo_yg/img_muslinTwoBibsTwoEars_yg.jpg";
import muslinTwoBibsTwoEarsP from "./muslinTwo_yg/img_muslinTwoBibsTwoEars_yg_p.jpg";

import muslinTwoBunny from "./muslinTwo_yg/img_muslinTwoBunny_yg.jpg";
import muslinTwoBunnyP from "./muslinTwo_yg/img_muslinTwoBunny_yg_p.jpg";

import muslinTwoBunnyEars from "./muslinTwo_yg/img_muslinTwoBunnyEars_yg.jpg";
import muslinTwoBunnyEarsP from "./muslinTwo_yg/img_muslinTwoBunnyEars_yg_p.jpg";

import muslinTwoBunnyEarsBib from "./muslinTwo_yg/img_muslinTwoBunnyEarsBib_yg.jpg";
import muslinTwoBunnyEarsBibP from "./muslinTwo_yg/img_muslinTwoBunnyEarsBib_yg_p.jpg";

import muslinTwoEars from "./muslinTwo_yg/img_muslinTwoEars_yg.jpg";
import muslinTwoEarsP from "./muslinTwo_yg/img_muslinTwoEars_yg_p.jpg";

import muslinTwoEarsBib from "./muslinTwo_yg/img_muslinTwoEarsBib_yg.jpg";
import muslinTwoEarsBibP from "./muslinTwo_yg/img_muslinTwoEarsBib_yg_p.jpg";

export default [
    {
        type: "muslinTwo",
        noPostcard: muslinTwo,
        withPostcard: muslinTwoP,
    },
    {
        type: "muslinTwoBibsTwo",
        noPostcard: muslinTwoBibsTwo,
        withPostcard: muslinTwoBibsTwoP,
    },
    {
        type: "muslinTwoBibsTwoEars",
        noPostcard: muslinTwoBibsTwoEars,
        withPostcard: muslinTwoBibsTwoEarsP,
    },
    {
        type: "muslinTwoBunny",
        noPostcard: muslinTwoBunny,
        withPostcard: muslinTwoBunnyP,
    },
    {
        type: "muslinTwoBunnyEars",
        noPostcard: muslinTwoBunnyEars,
        withPostcard: muslinTwoBunnyEarsP,
    },
    {
        type: "muslinTwoBunnyEarsBib",
        noPostcard: muslinTwoBunnyEarsBib,
        withPostcard: muslinTwoBunnyEarsBibP,
    },
    {
        type: "muslinTwoEars",
        noPostcard: muslinTwoEars,
        withPostcard: muslinTwoEarsP,
    },
    {
        type: "muslinTwoEarsBib",
        noPostcard: muslinTwoEarsBib,
        withPostcard: muslinTwoEarsBibP,
    }
]